module.exports = __webpack_public_path__ + "static/media/skull-crossbones.b0d1495f.svg";